<template>
    <div class="toTop" @click="toTop"></div>
</template>
<style lang="less" scoped>
.toTop{
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color:@expertFontColor255;
    background-image: url(../../assets/images/icon/totop.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 19px;
    box-shadow:0px 4px 10px 0px rgba(0,0,0,0.24);
    position: fixed;
    bottom: 48px;
    right: 12px;
    z-index: 97;
    font-size:@indexFontSize20;
    text-align: center;
    display: none;
}
</style>
<script>
export default {
    name:"toTop",
    data() {
        return {
            
        }
    },
    mounted(){
        $(window).scroll(function(){
            if($(window).scrollTop()>$(window).height()){
                $(".toTop").fadeIn();
            }else{
                $(".toTop").fadeOut();
            }
        })
    },
    methods:{
        toTop: function(){
            $('body,html').animate({ scrollTop: 0 }, 500);
        }
    }
}
</script>